// extracted by mini-css-extract-plugin
export default {"SectionHeading":"SectionHeading__SectionHeading___Sazpe fonts__whitney-semibold___M7vMo"};